import { Get } from "../http/httpVerbs";

export const apiGetCommunityCreator = async (communityId, creatorId) => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/comunidades/${communityId}/creators/${creatorId}`;
        const response = await Get(url);
        return response;
    } catch (error) {
        console.error("Error fetching community creator:", error);
        throw error;
    }
};
